import { withInstall } from '@hd-front-end/utils'
import CascaderPanel from './src/index.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElCascaderPanel: SFCWithInstall<typeof CascaderPanel> =
  withInstall(CascaderPanel)

export default ElCascaderPanel
export * from './src/types'
export * from './src/config'
export * from './src/instance'
